// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KSPt5","label":"styles_label__3LR3q"};